import { solanaClient } from '../clients/SolanaClient'
import { COMMISSIONS_WALLETS, SOL_COMMISSION_WALLET } from '../constants/business'
import { SOL_ID } from '../constants/tokenIds'
import { sendSol, sendSpl, transferToken } from '../handlers/walletActions/wallet'
import { Chain, PlugToken } from '../interfaces/common'
import { logger } from '../logger'
import { Wallet } from '../providers/WalletProvider'
import { asSolanaToken } from './castToken'

const getCommissionWallet = () => {
  const randomIndex = Math.floor(Math.random() * COMMISSIONS_WALLETS.length)

  return COMMISSIONS_WALLETS[randomIndex]
}

export const transferPlugCommission = async (
  commission: bigint,
  token: PlugToken,
  memo?: number,
  wallet?: Wallet
) => {
  if (token.chain === Chain.ICP || token.chain === Chain.ODIN) {
    if (commission <= (token.fee || 0)) return

    try {
      await transferToken({
        standard: token.standard,
        tokenCanisterId: token.address,
        receiver: {
          address: getCommissionWallet(),
        },
        amount: (commission - token.fee).toString(),
        memo,
        tokenId: token.id,
        chain: token.chain,
      })
    } catch (e) {
      logger.error('Failed to transfer Plug IC commission', {
        originalError: e,
        token: token.id,
        memo,
      })
    }
  } else if (token.chain === Chain.SOL && wallet?.solAddress) {
    const params = {
      to: SOL_COMMISSION_WALLET,
      from: wallet.solAddress,
      amount: commission.toString(),
    }

    try {
      if (token.id === SOL_ID) {
        await sendSol({ ...params, amount: (commission - token.fee).toString() })
      } else {
        const hasAssociatedTokenAccount = await solanaClient.hasAssociatedTokenAccount(
          SOL_COMMISSION_WALLET,
          asSolanaToken(token)
        )

        if (hasAssociatedTokenAccount) {
          const { address, decimals, additionalData } = asSolanaToken(token)
          await sendSpl({ ...params, token: { address, decimals, additionalData } })
        } else {
          logger.error(
            'Cannot transfer SOL commission because associated token account is not created',
            { token }
          )
        }
      }
    } catch (e) {
      logger.error('Failed to transfer Plug SOL commission', { originalError: e, token, memo })
    }
  }
}
